class CartCheckboxUpsell {
  constructor(cartItemsInstance) {
    this.cartItemsInstance = cartItemsInstance;
    this.variantId = this.getVariantId();
    this.isProgrammaticChange = false;
    this.isProcessing = false;
    
    this.init();
  }

  init() {
    this.initEvents();
    this.initObserver();
    this.updateCheckboxState();
  }

  getVariantId() {
    // Agora busca o ID da variação diretamente do nosso novo elemento <select>
    const select = document.querySelector('#cart-upsell-variant-select');
    return select ? select.value : null;
  }

  initEvents() {
    document.body.addEventListener('change', (e) => {
      // 1. Lógica quando o cliente clica no Checkbox
      if (e.target.id === 'cart-upsell-checkbox') {
        if (this.isProgrammaticChange) {
          this.isProgrammaticChange = false;
          return;
        }
        
        if (this.isProcessing) {
          e.target.checked = !e.target.checked;
          return;
        }
        
        this.variantId = this.getVariantId();
        
        // Exibe ou oculta o menu de opções dependendo se marcou ou desmarcou
        const wrapper = document.querySelector('#cart-upsell-variants-wrapper');
        if (wrapper) {
            wrapper.style.display = e.target.checked ? 'block' : 'none';
        }
        
        if (e.target.checked) {
          this.addToCart();
        } else {
          this.removeFromCart();
        }
      }

      // 2. Lógica quando o cliente muda a variação no dropdown (Select)
      if (e.target.id === 'cart-upsell-variant-select') {
         const checkbox = document.querySelector('#cart-upsell-checkbox');
         const oldVariantId = this.variantId;
         const newVariantId = e.target.value;

         this.variantId = newVariantId;

         // Se a embalagem já está no carrinho e o cliente trocou a cor/modelo, fazemos a troca
         if (checkbox && checkbox.checked && !this.isProcessing) {
             this.swapInCart(oldVariantId, newVariantId);
         }
      }
    });

    document.addEventListener('cartUpdated', () => {
      setTimeout(() => this.updateCheckboxState(), 500);
    });
  }

  initObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) {
            const checkbox = node.id === 'cart-upsell-checkbox' ? node : node.querySelector?.('#cart-upsell-checkbox');
            
            if (checkbox) {
              this.isProgrammaticChange = false;
              this.variantId = this.getVariantId();
              setTimeout(() => this.updateCheckboxState(), 200);
            }
          }
        });
      });
    });

    const target = document.querySelector('cart-drawer') 
                || document.querySelector('cart-items') 
                || document.querySelector('#main-cart-items')
                || document.body;
    
    observer.observe(target, { childList: true, subtree: true });
  }

  updateCheckboxState() {
    if (this.isProcessing) {
      return;
    }
    
    const select = document.querySelector('#cart-upsell-variant-select');
    // Coleta todos os IDs das opções de embalagem de presente
    const availableIds = select ? Array.from(select.options).map(o => o.value) : [];
    
    if (availableIds.length === 0) return;

    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        // Verifica se QUALQUER uma das variações de embalagem está no carrinho
        const itemInCart = cart.items.find(item => availableIds.includes(item.variant_id.toString()));
        
        const checkbox = document.querySelector('#cart-upsell-checkbox');
        const wrapper = document.querySelector('#cart-upsell-variants-wrapper');
        
        const hasUpsell = !!itemInCart;
        
        if (checkbox && checkbox.checked !== hasUpsell) {
          this.isProgrammaticChange = true;
          checkbox.checked = hasUpsell;
          
          setTimeout(() => {
            this.isProgrammaticChange = false;
          }, 50);
        }

        // Mantém o dropdown visível caso a página recarregue e o item já esteja no carrinho
        if (wrapper) {
            wrapper.style.display = hasUpsell ? 'block' : 'none';
        }

        // Sincroniza o dropdown selecionado com o que está efetivamente no carrinho
        if (itemInCart && select) {
            select.value = itemInCart.variant_id.toString();
            this.variantId = itemInCart.variant_id.toString();
        } else if (select) {
            this.variantId = select.value;
        }
      })
      .catch(err => console.error('Error fetching cart:', err));
  }

  // Nova função para trocar a variação sem precisar desmarcar o checkbox
  swapInCart(oldId, newId) {
     if (this.isProcessing) return;
     this.isProcessing = true;

     const updates = {};
     updates[oldId] = 0; // Remove o antigo
     updates[newId] = 1; // Adiciona o novo

     fetch('/cart/update.js', {
         method: 'POST',
         headers: { 'Content-Type': 'application/json' },
         body: JSON.stringify({ updates })
     })
     .then(r => r.json())
     .then(() => {
          if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
             this.cartItemsInstance.onCartUpdate();
          }
          this.updateSections();
     })
     .catch(err => {
         console.error('Error swapping cart item:', err);
     })
     .finally(() => {
          setTimeout(() => { this.isProcessing = false; }, 1000);
     });
  }

  addToCart() {
    if (this.isProcessing) return;
    
    this.isProcessing = true;
    
    const formData = new FormData();
    formData.append('id', this.variantId);
    formData.append('quantity', 1);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(r => r.json())
    .then(() => {
      if (this.cartItemsInstance && typeof this.cartItemsInstance.onCartUpdate === 'function') {
        this.cartItemsInstance.onCartUpdate();
      }
      
      this.updateSections();
    })
    .catch(err => {
      console.error('Error adding to cart:', err);
      this.isProgrammaticChange = true;
      const checkbox = document.querySelector('#cart-upsell-checkbox');
      if (checkbox) checkbox.checked = false;
    })
    .finally(() => {
      setTimeout(() => {
        this.isProcessing = false;
      }, 500);
    });
  }

  removeFromCart() {
    if (this.isProcessing) return;
    
    this.isProcessing = true;
    
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const lineItemIndex = cart.items.findIndex(item => item.variant_id.toString() === this.variantId);
        
        if (lineItemIndex === -1) {
          console.error('Upsell product not found in cart');
          this.isProcessing = false;
          return;
        }
        
        const line = lineItemIndex + 1;
        
        if (this.cartItemsInstance && typeof this.cartItemsInstance.updateQuantity === 'function') {
          this.cartItemsInstance.updateQuantity(line, 0, document.querySelector(`[data-index="${line}"]`));
          
          setTimeout(() => {
            this.isProcessing = false;
          }, 1000);
        } else {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line, quantity: 0 })
          })
          .then(r => r.json())
          .then(() => {
            this.updateSections();
          })
          .finally(() => {
            setTimeout(() => {
              this.isProcessing = false;
            }, 1000);
          });
        }
      })
      .catch(err => {
        console.error('Error removing from cart:', err);
        this.isProgrammaticChange = true;
        const checkbox = document.querySelector('#cart-upsell-checkbox');
        if (checkbox) checkbox.checked = true;
        
        this.isProcessing = false;
      });
  }

  updateSections() {
    this.getSections().forEach(section => {
      fetch(`${routes.cart_url}?section_id=${section.section}`)
        .then(r => r.text())
        .then(html => {
          const doc = new DOMParser().parseFromString(html, "text/html");
          this.renderSection(section, doc, html);
        })
        .catch(err => console.error(`Error updating ${section.id}:`, err));
    });
  }

  renderSection(section, doc, html) {
    if (section.id === 'main-cart-items') {
      const newContents = doc.querySelectorAll('.js-contents');
      const currentContents = document.querySelectorAll('.js-contents');
      
      newContents.forEach((newContent, i) => {
        const current = currentContents[i];
        if (current && newContent) {
          current.innerHTML = newContent.innerHTML;
        }
      });
    } else if (section.id === 'cart-icon-bubble') {
      const container = document.querySelector(section.selector);
      if (container) {
        container.innerHTML = html;
      }
    } else {
      const newEl = doc.querySelector(section.selector);
      const currentEl = document.querySelector(section.selector);
      if (currentEl && newEl) {
        currentEl.innerHTML = newEl.innerHTML;
      }
    }
  }

  getSections() {
    const mainCartItems = document.getElementById('main-cart-items');
    const cartSections = ['main-cart-items', 'main-cart-shipping', 'main-cart-discount', 'main-cart-total']
      .filter(() => mainCartItems)
      .map(id => ({
        id,
        section: mainCartItems.dataset.id,
        selector: id === 'main-cart-items' ? '.js-contents' : `#${id}`
      }));

    return [...cartSections, { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '#cart-icon-bubble' }];
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const cartInstance = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
  
  if (cartInstance) {
    window.cartUpsellInstance = new CartCheckboxUpsell(cartInstance);
    
    if (typeof cartInstance.updateQuantity === 'function') {
      const originalUpdate = cartInstance.updateQuantity.bind(cartInstance);
      
      cartInstance.updateQuantity = function(...args) {
        const result = originalUpdate(...args);
        
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent('cartUpdated'));
        }, 300);
        
        return result;
      };
    }
  }
});